/* @flow */
import liferay from 'services/liferay';
import type { Action, AsyncAction, SaveProductionParams, Production } from 'types/index';

const onFailure = (error: Object) => console.warn(error);

const fetchProductionList = (): AsyncAction => {
  return {
    type: 'FETCH_PRODUCTION_LIST_REQUEST',
    promise: liferay.productions.find(),
    meta: { onFailure },
  };
};

const fetchProduction = (id: number): AsyncAction => {
  return {
    type: 'FETCH_PRODUCTION_REQUEST',
    payload: id,
    promise: liferay.productions.get(id),
    meta: { onFailure },
  };
};

const createProduction = (): Action => {
  return {
    type: 'CREATE_PRODUCTION',
    meta: { onFailure },
  };
};

const saveProduction = (
  params: SaveProductionParams,
  onSuccess?: (production: Production) => any
): AsyncAction => {
  // $FlowFixMe
  const promise: Promise<Production> = params.id
    ? //$FlowFixMe
      liferay.productions.update(params)
    : liferay.productions.create(params);
  return {
    type: 'SAVE_PRODUCTION_REQUEST',
    promise,
    meta: { onFailure, onSuccess },
  };
};

const deleteProduction = (id: number, onSuccess?: (id: number) => any): AsyncAction => {
  return {
    type: 'DELETE_PRODUCTION_REQUEST',
    payload: id,
    promise: liferay.productions.delete(id),
    meta: { onFailure, onSuccess },
  };
};

export default {
  fetchProductionList,
  fetchProduction,
  createProduction,
  saveProduction,
  deleteProduction,
};
